import Vue from "vue";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component, Watch } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import MesesDoAno from "@/models/enum/mesesDoAno";
import PDFService from "@/services/pdf/PDFService";

import "../crud.scss";

@Component({
    components: {
        fieldsetComponent,
        actionBarComponent,
        comboComponent,
        dateTimePickerComponent,
    },
})
export default class RegistroReceituarioComponent extends Vue {
    private service = new PDFService("RegistroReceituarioPDF");

    tipoPeriodoId: number = null;
    responsavelId: number = null;
    tipoControleId = 1;
    periodoId: number = null;
    ano: number = null;
    mes: number = null;
    dataInicialCustomizada = new Date();
    dataFinalCustomizada = new Date();

    tipoPeriodoOptions: Array<Object> = [
        { text: "Semestral", value: 1 },
        { text: "Trimestral", value: 2 },
        { text: "Mensal", value: 3 },
        { text: "Customizado", value: 4 },
    ];

    responsavelOptions: Array<Object> = [
        { text: "Farmacêutico", value: 1 },
        { text: "Veterinário MAPA", value: 2 },
    ];

    tipoControleOptions: Array<object> = [
        { text: "ANVISA", value: 1 },
        { text: "MAPA", value: 2 },
        { text: "GERAL", value: 3 },
    ];

    semestralOptins: Array<object> = [
        { text: "1º Semestre", value: 6 },
        { text: "2º Semestre", value: 7 },
    ];

    trimestralOptins: Array<object> = [
        { text: "1º Trimestre", value: 1 },
        { text: "2º Trimestre", value: 2 },
        { text: "3º Trimestre", value: 3 },
        { text: "4º Trimestre", value: 4 },
    ];

    mesesOptions = EnumExtensions.getNamesAndValuesOrderedByValues(MesesDoAno);

    private load() {
        this.ano = new Date().getFullYear();
    }

    private async save() {
        try {
            this.$validator.detach("dataCustomizada");
            this.$validator.detach("dataInicialCustomizada");
            this.$validator.detach("dataFinalCustomizada");
            this.$validator.detach("periodoId");
            this.$validator.detach("mes");

            if (this.tipoPeriodoId === 4) {
                this.$validator.attach({
                    name: "dataInicialCustomizada",
                    rules: !this.dataInicialCustomizada ? "required" : "",
                });
                this.$validator.attach({
                    name: "dataFinalCustomizada",
                    rules: !this.dataFinalCustomizada ? "required" : "",
                });
            } else if (this.tipoPeriodoId === 3) {
                this.$validator.attach({
                    name: "mes",
                    rules: this.mes == 0 ? "required|maior_que_zero" : "",
                });
            } else if (this.tipoPeriodoId === 1 || this.tipoPeriodoId === 2) {
                this.$validator.attach({
                    name: "periodoId",
                    rules: !this.periodoId ? "required" : "",
                });
            }

            const isValid = await this.$validator.validateAll();

            if (isValid) {
                const filters = {
                    periodo: this.periodoId,
                    responsavel: this.responsavelId,
                    tipoControle: this.tipoControleId,
                    ano: this.ano,
                    mes: this.mes,
                    dataInicialCustomizada: this.tipoPeriodoId === 4 ? this.dataInicialCustomizada : null,
                    dataFinalCustomizada: this.tipoPeriodoId === 4 ? this.dataFinalCustomizada : null,
                };

                await this.service.geraPDFWithFilters(filters);

                this.$showSuccess("Sucesso", "Arquivo foi gerado corretamente.");
            }
        } catch (e) {
            this.$showError("Erro", `Erro ao gerar o arquivo.\n Erro: ${e.message}`);
        }
    }

    private cancel() {
        this.$router.back();
    }

    @Watch("tipoPeriodoId")
    private async onChangeTipoPeriodoId() {
        await this.$nextTick();

        this.periodoId = null;
        this.mes = 0;

        this.dataInicialCustomizada = null;
        this.dataFinalCustomizada = null;

        if (this.tipoPeriodoId === 4) {
            this.dataFinalCustomizada = new Date();
            this.dataInicialCustomizada = new Date();
        }
    }

    private async mounted() {
        this.load();
    }
}
